'use client'

import React, { useCallback } from 'react'
import { useTranslations } from 'next-intl'

import type { HolidayCollectionIndexEntry } from '@/src/types/holidays'
import useClevertapForHolidays from '@/src/hooks/analytics/clevertap/holidays'
import useHolidayAppMode from '@/src/hooks/holidays/useHolidayAppMode'
import { HOLIDAY_ACTION, HOLIDAY_ACTION_TYPE } from '@/src/utils/analytics/holidays/holidayEvents'
import { buildCollectionHref, withHolidayAppMode } from '@/src/utils/holidays'

import CollectionIndex from './collectionIndex'

interface CollectionIndexWrapperProps {
    entries: HolidayCollectionIndexEntry[]
    isMobile: boolean
}

const CollectionIndexWrapper: React.FC<CollectionIndexWrapperProps> = ({ entries, isMobile }) => {
    const t = useTranslations('holidaysPage')
    const { triggerHolidayUIActionEvent } = useClevertapForHolidays()
    const isApp = useHolidayAppMode()

    const views = entries.map(entry => ({
        slug: entry.slug,
        href: withHolidayAppMode(buildCollectionHref(entry.slug), isApp),
        title: entry.title,
        description: entry.description
    }))

    const handleSelect = useCallback(
        (index: number) => {
            const entry = entries[index]
            if (!entry) return

            triggerHolidayUIActionEvent(HOLIDAY_ACTION.CATEGORY_SELECTED, {
                action_type: HOLIDAY_ACTION_TYPE.NAVIGATION,
                campaign_theme: entry.slug,
                collection_slug: entry.slug,
                collection_name: entry.title,
                card_position: index + 1
            })
        },
        [entries, triggerHolidayUIActionEvent]
    )

    return (
        <CollectionIndex
            heading={t('indexHeading')}
            subheading={t('indexSubheading')}
            entries={views}
            emptyLabel={t('indexEmpty')}
            onSelect={handleSelect}
            isMobile={isMobile}
        />
    )
}

export { CollectionIndexWrapper }
export default CollectionIndexWrapper
